import React, { useState, useEffect, useRef } from 'react';
import SimpleBar from 'simplebar-react';
import { Link, useHref } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { getFirebaseBackend } from 'helpers/firebaseHelper';
import { useAuth } from 'hooks/useAuth';
import { SidebarContentStyles } from './styles';

const SidebarContent = () => {
  const firebaseHelper = getFirebaseBackend();

  const { user } = useAuth();
  const { t: translate } = useTranslation();
  const barRef = useRef();
  const currentRoute = useHref();
  const isAdminStatus = ['Super Admin', 'Admin'].includes(user.adminStatus);

  const [accountModules, setAccountModules] = useState({});

  const verifyRoute = (route) => {
    if (!currentRoute.endsWith(route) && route !== '/') {
      return false;
    }
    if (currentRoute.startsWith(route) && route !== '/') {
      return true;
    }
    if (currentRoute === route) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (!user?.account) return;
    return firebaseHelper.listenAccountModules(user.account, setAccountModules);
  }, [user?.account]);

  useEffect(() => {
    barRef.current.recalculate();
  });

  return (
    <SidebarContentStyles>
      <SimpleBar className="h-100" ref={barRef} forceVisible={true} autoHide={false}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li>
              <Link to={user.adminStatus === 'Reviewer' ? '/guidelines' : '/#'} className="">
                <i className={'bx bx-home-circle' + (verifyRoute('/') ? ' link-bold-white' : '')} />
                <span className={verifyRoute('/') ? ' link-bold-white' : ''}>
                  {translate('Home')}
                </span>
              </Link>
            </li>

            {/* {user?.modules?.content && accountModules?.content && (
              <li>
                <QuickMenuLink to="/old-guideline/manage">
                  <i
                    className={
                      'bx bx-bell m-0' +
                      (verifyRoute('/old-guideline/manage') ? ' link-bold-white' : '')
                    }
                  />
                  <span
                    className={'' + (verifyRoute('/old-guideline/manage') ? ' link-bold-white' : '')}
                  >
                    {translate('My Activity')}
                  </span>
                </QuickMenuLink>
              </li>
            )} */}

            <li className="menu-title mt-3">{translate('Apps')}</li>

            {user?.modules?.tasks && accountModules?.tasks && (
              <li>
                <Link to="/tasks">
                  <i className="bx bx-calendar-check" />
                  <span>{translate('Tasks')}</span>
                </Link>
                <ul>
                  <li>
                    <Link to="/tasks" className={verifyRoute('/tasks') ? 'link-bold-white' : ''}>
                      {translate('Kanban')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/tasks-list"
                      className={verifyRoute('/tasks-list') ? 'link-bold-white' : ''}
                    >
                      {translate('List')}
                    </Link>
                  </li>
                  {user?.modules?.meetings && (
                    <li>
                      <Link
                        to="/meetings"
                        className={verifyRoute('/meetings') ? 'link-bold-white' : ''}
                      >
                        {translate('Meetings')}
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {isAdminStatus && user?.modules?.content && accountModules?.content ? (
              <li>
                <Link to="/guidelines">
                  <i className="bx bx-file" />
                  <span>{translate('Content')}</span>
                </Link>
                <ul>
                  <li>
                    <Link
                      to="/guidelines"
                      className={verifyRoute('/guidelines') ? 'link-bold-white' : ''}
                    >
                      {translate('Guidelines')}
                    </Link>
                  </li>
                </ul>
              </li>
            ) : (
              <></>
            )}

            {/* {user?.modules?.seo && accountModules?.seo && (
              <li>
                <Link to="/tasks">
                  <i className="bx bx-calendar-check" />
                  <span>SEO</span>
                </Link>
                <ul>
                  <li>
                    <Link
                      to="/new-tasks"
                      className={
                        verifyRoute('/new-tasks') && !verifyRoute('/tasks') ? 'link-bold-white' : ''
                      }
                    >
                      {translate('Kanban')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/new-tasks-list"
                      className={
                        verifyRoute('/new-tasks-list') && !verifyRoute('/tasks-list')
                          ? 'link-bold-white'
                          : ''
                      }
                    >
                      {translate('List')}
                    </Link>
                  </li>
                </ul>
              </li>
            )} */}

            {/* {user.modules.paidMedia && accountModules.paidMedia && (
              <li>
                <Link to="/campaigns">
                  <i className="bx bx-news" />
                  <span>{translate('PaidMedia')}</span>
                </Link>
                <ul>
                  <li>
                    <Link
                      to="/campaigns"
                      className={verifyRoute('/campaigns') ? 'link-bold-white' : ''}
                    >
                      {translate('Kanban')}
                    </Link>
                  </li>
                </ul>
              </li>
            )} */}

            {user.modules.keywordReport && accountModules.keywordReport && (
              <li>
                <Link to="/reports/keywords">
                  <i className="bx bx-pulse" />
                  <span>{translate('Keywords')}</span>
                </Link>
                <ul>
                  <li>
                    <Link
                      to="/reports/keywords"
                      className={verifyRoute('/reports/keywords') ? 'link-bold-white' : ''}
                    >
                      {translate('Monitoring')}
                    </Link>
                    {isAdminStatus && (
                      <Link
                        to="/reports/keywords/groups"
                        className={verifyRoute('/reports/keywords/groups') ? 'link-bold-white' : ''}
                      >
                        {translate('Groups')}
                      </Link>
                    )}
                  </li>
                </ul>
              </li>
            )}

            {user?.modules?.courses && accountModules?.courses && (
              <li>
                <Link to="/#">
                  <i className="bx bx-book" />
                  <span>{translate('Education')}</span>
                </Link>
                <ul>
                  <li>
                    <Link
                      to="/lessons"
                      className={verifyRoute('/lessons') ? 'link-bold-white' : ''}
                    >
                      {translate('Lessons')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/courses"
                      className={verifyRoute('/courses') ? 'link-bold-white' : ''}
                    >
                      {translate('Courses')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/tests" className={verifyRoute('/tests') ? 'link-bold-white' : ''}>
                      {translate('Tests')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/library"
                      className={verifyRoute('/library') ? 'link-bold-white' : ''}
                    >
                      {translate('My Library')}
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            <li>
              <Link to="/changelog">
                <i className="bx bx-wrench" />
                <span>{translate('Support')}</span>
              </Link>
              <ul>
                <li>
                  <Link
                    to="/changelog"
                    className={verifyRoute('/changelog') ? 'link-bold-white' : ''}
                  >
                    {translate("What's New")}
                  </Link>
                </li>
              </ul>
            </li>

            {user.adminStatus === 'Super Admin' &&
              user?.modules?.tasks &&
              accountModules?.tasks && (
                <li>
                  <Link to="/old-tasks">
                    <i className="bx bx-calendar-check" />
                    <span>{translate('Tasks (LEGACY)')}</span>
                  </Link>
                  <ul>
                    <li>
                      <Link
                        to="/old-tasks"
                        className={verifyRoute('/old-tasks') ? 'link-bold-white' : ''}
                      >
                        {translate('Kanban')}
                      </Link>
                    </li>
                  </ul>
                </li>
              )}
            {user.adminStatus === 'Super Admin' &&
            user?.modules?.content &&
            accountModules?.content ? (
              <li>
                <Link to="/old-guidelines">
                  <i className="bx bx-file" />
                  <span>{translate('ContentOld')}</span>
                </Link>
                <ul>
                  <li>
                    <Link
                      to="/old-guidelines"
                      className={
                        verifyRoute('/content') || verifyRoute('/old-guidelines')
                          ? 'link-bold-white'
                          : ''
                      }
                    >
                      {translate('Guidelines')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/old-guidelines-list"
                      className={verifyRoute('/old-guidelines-list') ? 'link-bold-white' : ''}
                    >
                      {translate('List')}
                    </Link>
                  </li>
                </ul>
              </li>
            ) : (
              <></>
            )}
          </ul>
        </div>
      </SimpleBar>
    </SidebarContentStyles>
  );
};

export default SidebarContent;
